import { useDispatch } from "react-redux";
import { decryptData } from "../redux/encryptiondecryption";
import actions from "../redux/Otp/actions";
import config from "../Services/apiEndPoints";

export const useCheckTokenExpiry = () => {
  const dispatch = useDispatch();

  const checkTokenExpiry = () => {
    const loginData = decryptData();
    const { accessToken, refreshToken, accessTokenExpiry } = loginData || {};
    const currentTime = Date.now();
    const expiryDate = new Date(accessTokenExpiry).getTime();
    const timeRemaining = expiryDate - currentTime;

    if (timeRemaining <= 2 * 60 * 1000 && refreshToken) {
      const payload = { token: refreshToken };
      dispatch(actions.refreshAccessToken(config.refreshTocken, payload));
    }
  };

  return { checkTokenExpiry };
};
